module.exports = __webpack_public_path__ + "static/media/target-altitude.7792e614.jpg";